import { useState, useMemo } from 'react';
export const usePaginatedTable = (data, pageSize) => {
  const [pageNumber, setPageNumber] = useState(1);
  const {
    startIndex,
    paginatedData,
    pageCount
  } = useMemo(() => {
    if (!(data !== null && data !== void 0 && data.length)) {
      return {
        startIndex: 0,
        paginatedData: [],
        pageCount: 0
      };
    }
    const start = (pageNumber - 1) * pageSize;
    const end = start + pageSize;
    return {
      startIndex: start,
      paginatedData: data.slice(start, end),
      pageCount: Math.ceil(data.length / pageSize)
    };
  }, [data, pageNumber, pageSize]);
  const handlePageChange = ({
    target: {
      value
    }
  }) => {
    setPageNumber(value);
  };
  return {
    pageNumber,
    handlePageChange,
    startIndex,
    paginatedData,
    pageCount
  };
};